import styled, { css } from 'styled-components'

import { toSizeUnit } from "../Functions"

export function match<T extends string | number | symbol, V>(
  value: T,
  handlers: { [key in T]: () => V },
): V {
  const handler = handlers[value]

  return handler()
}


type BorderRadiusSize = 'xs' | 's' | 'm'

export const borderRadius: Record<BorderRadiusSize, ReturnType<typeof css>> = {
  xs: css`
    border-radius: 4px;
  `,
  s: css`
    border-radius: 8px;
  `,
  m: css`
    border-radius: 12px;
  `,
}



type PanelKind = 'regular' | 'secondary'

export interface PanelProps {
  padding?: React.CSSProperties['padding']
  direction?: React.CSSProperties['flexDirection']

  kind?: PanelKind

  withSections?: boolean
}

export const panelDefaultPadding = 20

export const panel = ({
  padding = panelDefaultPadding,
  direction = 'column',
  kind = 'regular',
  withSections = false,
}: PanelProps = {}) => {
  return css`
    ${borderRadius.m};

    overflow: hidden;

    ${({ theme }) => {
      const contentBackground = match(kind, {
        secondary: () => theme.colors.background.toCssValue(),
        regular: () => 'transparent' // getColor('mist'),
      })

      const content = css`
        padding: ${toSizeUnit(padding)};
        background: ${contentBackground};
      `

      if (!withSections) {
        return content
      }

      return css`
        display: flex;
        flex-direction: ${direction};

        ${kind === 'secondary'
          ? css`
              background: #aaa};
              gap: 2px;
            `
          : css`
              gap: 1px;
            `}

        > * {
          ${content}
        }
      `
    }}

    ${kind === 'secondary' &&
    css`
      border: 2px solid #aaa};
    `}
  `
}

export const Panel = styled.div<PanelProps>`
  ${panel}
`
